import { render } from "./QuestPage.vue?vue&type=template&id=f4c310bc&scoped=true"
import script from "./QuestPage.vue?vue&type=script&lang=js"
export * from "./QuestPage.vue?vue&type=script&lang=js"

import "./QuestPage.vue?vue&type=style&index=0&id=f4c310bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c310bc"]])

export default __exports__